import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {EventsService} from '../events/events.service';
import {AuthenticationService} from '../../authentication.service';
import {DomSanitizer} from '@angular/platform-browser';
import {GlobalService} from '../../global.service';
import {Router} from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'elastic-livestreams',
  templateUrl: './livestreams.component.html',
  styleUrls: ['./livestreams.component.scss']
})
export class LivestreamsComponent implements OnInit, OnDestroy {

  anybodyLive = false;
  upcomingBroadcasts = [];
  show = false;
  closed = true;
  timer: any;
  constructor(
    private eventsService: EventsService,
    private auth: AuthenticationService,
    private cd: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private globalService: GlobalService,
    private router: Router
  ) { }

  ngOnInit() {
    this.globalService.shuffle(this.globalService.content_creators);

    let array = [];

    this.globalService.official_channels.forEach( (data: any) => {
      array.push(data);
    });
    this.globalService.content_creators.forEach( (data: any) => {
      array.push(data);
    });

    this.globalService.channelNames = _.cloneDeep(array);
    console.log(this.router.url);

    setTimeout( () => {
      this.getBroadcasts();
    }, 3000);

    this.timer = setInterval( () => {
      this.getBroadcasts();
    }, 60000);

  }

  getBroadcasts() {
    this.anybodyLive = false;

    this.eventsService.getUpcomingBroadcasts().subscribe(

      ( response: HttpEvent<any> ) => {

        switch (response.type) {
          case HttpEventType.Response:



            if (response.body.data.length > 0) {
              response.body.data.forEach( ( broadcast: any) => {
                broadcast.embedLink = this.sanitizer.bypassSecurityTrustResourceUrl(broadcast.embedLink);
                broadcast.live_date = new Date(broadcast.live_date);
                broadcast.is_live = new Date() > broadcast.live_date ? true : false;
                if (broadcast.is_live) {
                  this.anybodyLive = true;
                }
                this.upcomingBroadcasts.push(broadcast);
              });
            }

            this.globalService.channelNames.forEach( (broadcast) => {
              if (broadcast.live && broadcast.link != undefined && !this.show) {
                // @ts-ignore
                this.show = broadcast;
                console.log("SHOW:");
                console.log(this.show);
              }
            });

            this.cd.detectChanges();
            console.log(this.upcomingBroadcasts);
            break;
        }
      });





  }

  ngOnDestroy() {

    clearInterval(this.timer);

  }

}
